import React from 'react'
import PropTypes from 'prop-types'
import { CloudinaryViewer } from 'shared/Components/VideoPlayer/CloudinaryViewer'
import { CLOUDINARY_VIDEO_SOURCE_TYPE } from 'shared/constants'

const PLAYER_ID = 'item-cld-player'

function ItemCloudinaryViewer(props) {

  const videoSourceConfig= {
    type: CLOUDINARY_VIDEO_SOURCE_TYPE.url,
    value: props.previewMetadata.url
  }

  return(
    <CloudinaryViewer
      videoSourceConfig={videoSourceConfig}
      playerId={PLAYER_ID}
      isScheduled={false}
    />
  )
}

ItemCloudinaryViewer.propTypes = {
  previewMetadata: PropTypes.object.isRequired
}

export default ItemCloudinaryViewer
